export const EXTERNAL_URLS = {
    TERMS_OF_SERVICE: 'https://www.quoiden.com/terms-of-service',
    PRIVACY_STATEMENT: 'https://www.quoiden.com/privacy-statement',
    COOKIE_POLICY: 'https://www.quoiden.com/cookie-policy',
    ABOUT_OTC_DEFICIENCY: 'https://www.quoiden.com/about-otc-deficiency',
};
/**
 * Validation regex for MDI MRN field
 * Allows alphanumeric characters and hyphens (e.g., "MDI-001", "ABC123")
 */
export const MDI_MRN_REGEX = /^[A-Za-z0-9\-]+$/;
